import base64 from 'react-native-base64';

import {
  appendPodcastFeedData,
  setPodcastFeedDataError,
  setPodcastFeedDataLoaded,
  setPodcastFeedDataLoading,
  setPodcastFeedOrder,
  setPodcastListAndEpisodesError,
  setPodcastListAndEpisodesLoaded,
  setPodcastListAndEpisodesLoading,
} from './slice';
import { getPodcastListAndEpisodes, getRssContent } from '../../../api/mobileApi';
import { AppThunk } from '../../../app/store';
import i18n from '../../../localization/i18n';
import { PodcastModel } from '../../../models/Podcast.model';
import { showAlert } from '../../modal/store/actions';

export const fetchPodcastListAndEpisodes =
  (tabId: number, list: string[], bearerToken: string): AppThunk =>
  async dispatch => {
    dispatch(setPodcastListAndEpisodesLoading({ tabId }));
    try {
      const result = await getPodcastListAndEpisodes(
        list,
        bearerToken,
        parseInt(process.env?.REACT_APP_APP_ID, 10),
      );
      dispatch(
        setPodcastListAndEpisodesLoaded({
          tabId,
          podcasts: [...result.podcasts],
          lastEpisodes: [...result.lastEpisodes],
        }),
      );
    } catch (e) {
      dispatch(setPodcastListAndEpisodesError({ tabId }));
      dispatch(
        showAlert({
          key: 'fetch-podcast-info-error',
          type: 'warning',
          text: i18n.t('alert.noConnection'),
          closable: false,
          autoCloseAfterMs: 2000,
        }),
      );
    }
  };

export const fetchPodcastFeed =
  (podcastUrl: string, bearerToken: string, order: 'desc' | 'asc' = 'desc'): AppThunk =>
  async dispatch => {
    dispatch(setPodcastFeedDataLoading({ podcastUrl }));
    try {
      const result = await getRssContent(
        base64.encode(podcastUrl),
        1,
        bearerToken,
        parseInt(process.env?.REACT_APP_APP_ID || '0', 10),
        order,
      );
      dispatch(
        setPodcastFeedDataLoaded({
          podcastUrl,
          podcastData: result as PodcastModel,
        }),
      );
    } catch (e) {
      dispatch(setPodcastFeedDataError({ podcastUrl }));
      dispatch(
        showAlert({
          key: 'fetch-podcast-episodes-error',
          type: 'warning',
          text: i18n.t('alert.noConnection'),
          closable: false,
          autoCloseAfterMs: 2000,
        }),
      );
    }
  };

export const fetchNextPodcastFeedPage =
  (
    podcastUrl: string,
    currentPage: number,
    bearerToken: string,
    order: 'desc' | 'asc' = 'desc',
  ): AppThunk =>
  async dispatch => {
    dispatch(setPodcastFeedDataLoading({ podcastUrl }));
    try {
      const result = await getRssContent(
        base64.encode(podcastUrl),
        currentPage + 1,
        bearerToken,
        parseInt(process.env?.REACT_APP_APP_ID || '0', 10),
        order,
      );
      dispatch(
        appendPodcastFeedData({
          podcastUrl,
          podcastData: result as PodcastModel,
        }),
      );
    } catch (e) {
      dispatch(setPodcastFeedDataError({ podcastUrl }));
      dispatch(
        showAlert({
          key: 'fetch-podcast-episodes-error',
          type: 'warning',
          text: i18n.t('alert.noConnection'),
          closable: false,
          autoCloseAfterMs: 2000,
        }),
      );
    }
  };

export const togglePodcastFeedOrder =
  (podcastUrl: string): AppThunk =>
  (dispatch, getState) => {
    const currentOrder =
      getState().podcastReducer.podcastFeeds?.[podcastUrl]?.order ?? 'desc';
    const newOrder = currentOrder === 'desc' ? 'asc' : 'desc';

    // update the order in state
    dispatch(setPodcastFeedOrder({ podcastUrl, order: newOrder }));

    // refetch with new order
    const bearerToken = getState().bearerTokenReducer.bearerToken;
    dispatch(fetchPodcastFeed(podcastUrl, bearerToken, newOrder));
  };
